import { defineMessages } from 'utils/intl';

export default defineMessages({
  info: `Administratorem Twoich danych osobowych jest {name} {typeOfCompany} ({addressWithoutCountry}, KRS: {krs}, NIP: {nip}).
    Twoje dane są u nas bezpieczne. {link} dowiesz się więcej o tym, jak chronimy Twoje dane.`,
  link: 'Tutaj',
});
